import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useForm } from '../../../../lib/components';
import { useStore } from '../../../../hooks/useStore';
import { ContactDataView } from './view';
import * as Yup from 'yup';
import { ProfileViewEditBox } from '../shared/profileViewEditBox';
import { ContactDataForm } from './form';

export const EmployeeProfilContactData = observer(() => {
  const { employeeStore } = useStore();
  const { employeeId } = useParams();
  const { t } = useTranslation();
  const form = useForm();
  const [canSubmit, setCanSubmit] = useState<boolean>(false);

  const renderView = observer(() => {
    return <ContactDataView data={employeeStore.currentEmployee?.contact_data} />;
  });

  const renderEdit = () => {
    return (
      <ContactDataForm
        initialValues={{
          email: employeeStore.currentEmployee?.contact_data.email || ''
        }}
        validationSchema={{
          email: Yup.string().required(t('form:FIELD_IS_REQUIRED')).email(t('form:INVALID_EMAIL'))
        }}
        formRef={form.formRef}
        onStateChanged={setCanSubmit}
        onSubmit={async (values) => {
          try {
            if (employeeId) {
              await employeeStore.updateEmployeeContactData(employeeId, values);
            }
          } catch (error) {
            console.error(error);
          }
        }}
      />
    );
  };

  return (
    <ProfileViewEditBox
      title={t('employee:CONTACT_DATA')}
      view={renderView}
      edit={renderEdit}
      canEdit
      canSubmit={canSubmit}
      onSubmit={form.handleSubmit}
      onCancel={form.handleReset}
    />
  );
});
